import type { MutableRefObject } from "react";
import { type TimeZoneMode, getTimeParts, pad } from "./timeZone";

export type AxisTimePrecision = "minute" | "second" | "millisecond";

const MONTH_NAMES = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

export const createAxisTimeFormatter = ({
	mode,
	precision,
	tickValuesRef,
}: {
	mode: TimeZoneMode;
	precision: AxisTimePrecision;
	tickValuesRef: MutableRefObject<number[]>;
}) => {
	return (value: number, index: number): string => {
		if (index === 0) {
			tickValuesRef.current = [];
		}
		const previousValue =
			index > 0 ? tickValuesRef.current[index - 1] : undefined;
		tickValuesRef.current.push(value);

		const parts = getTimeParts(value, mode);
		const hhmm = `${pad(parts.hours)}:${pad(parts.minutes)}`;
		const ss = pad(parts.seconds);
		const sss = pad(parts.milliseconds, 3);
		const time =
			precision === "minute"
				? hhmm
				: precision === "second"
					? `${hhmm}:${ss}`
					: `${hhmm}:${ss}.${sss}`;
		const monthName = MONTH_NAMES[parts.month];

		if (index === 0) {
			return `${monthName} ${parts.day}, ${parts.year}\n${time}`;
		}

		if (previousValue !== undefined) {
			const previous = getTimeParts(previousValue, mode);
			if (
				previous.day !== parts.day ||
				previous.month !== parts.month ||
				previous.year !== parts.year
			) {
				return `${monthName} ${parts.day}\n${time}`;
			}
		}

		return time;
	};
};
